import React from 'react';
import { Bell } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';
import { PageHeader } from '../components/common';
import NotificationPanel from '../components/NotificationPanel';

export default function Notifications() {
  const { t } = useI18n();
  return (
    <div data-testid="notifications-page">
      <PageHeader icon={Bell} title={t('nav.notifications')} subtitle={t('set.notificationsDesc')} />
      <div className="p-4 md:p-8 max-w-2xl">
        <div className="kmt-panel p-6"><NotificationPanel /></div>
      </div>
    </div>
  );
}
